// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.grey--text[data-v-63f98cb4] {\n  color: #9e9e9e !important;\n}\n.flight-divider[data-v-63f98cb4] {\n  font-weight: 700;\n  position: relative;\n  top: -11px;\n}\n", ""]);
// Exports
module.exports = exports;
